import React from "react";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";

export default function CreditRecommendations() {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Typography variant="subtitle2" color="text.secondary" mb={2}>
        Credit Improvement Recommendations
      </Typography>

      {/* Recommendation 1 - Green */}
      <Box
        sx={{
          bgcolor: "#e8f5e9",
          border: "1px solid #c8e6c9",
          borderRadius: 2,
          p: 2,
          mb: 2,
        }}
      >
        <Typography variant="body2" fontWeight="bold" color="success.main">
          Excellent Payment History
        </Typography>
        <Typography variant="body2" mt={0.5}>
          Keep up the great work! Your consistent on-time payments across all 8 credit accounts are your strongest credit asset.
        </Typography>
      </Box>

      {/* Recommendation 2 - Blue */}
      <Box
        sx={{
          bgcolor: "#e3f2fd",
          border: "1px solid #90caf9",
          borderRadius: 2,
          p: 2,
          mb: 3,
        }}
      >
        <Typography variant="body2" fontWeight="bold" color="primary.main">
          Consider Credit Limit Increases
        </Typography>
        <Typography variant="body2" mt={0.5}>
          With your excellent payment history across 8 accounts, request credit limit increases to improve your utilization ratio.
        </Typography>
      </Box>

      {/* Buttons */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{ borderRadius: 2, textTransform: "none", flex: 1 }}
        >
          Get Full Credit Report
        </Button>
        <Button
          variant="outlined"
          color="primary"
          sx={{ borderRadius: 2, textTransform: "none", flex: 1 }}
        >
          Set Credit Monitoring
        </Button>
      </Box>
    </Card>
  );
}
